<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M41 7.05V35H26l-.78.57L19 40.12V35H7V7h34m1-3H6a2 2 0 00-2 2v30a2 2 0 002 2h10v4.07a2 2 0 002 2 2 2 0 001.17-.39L27 38h15a2 2 0 002-2V6a2 2 0 00-2-2z"/></svg>